const Sport = () => {
    return (  
            <svg height="50px" width="50px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 25.726 25.726" xmlSpace="preserve" fill="#000000" transform="matrix(-1, 0, 0, 1, 0, 0)">

                <g id="SVGRepo_bgCarrier" stroke-width="0"/>
                
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
                
                <g id="SVGRepo_iconCarrier"> <g> <g> <circle style={{fill:'#85ba84'}} cx="3.35" cy="2.813" r="2.813"/> </g> <g> <path style={{fill:'#85ba84'}} d="M5.018,11.613l9.561,9.56c-1.177-0.019-2.352-0.225-3.461-0.667 c-0.445-0.084-2.235-0.374-2.918,0.309c-1.563,1.563-2.991,3.697-3.773,4.479c-0.781,0.781-1.89,0.456-2.938-0.592 c-1.049-1.049-1.35-2.18-0.592-2.938s2.916-2.209,4.48-3.773c0.716-0.717,0.344-2.699,0.287-2.979 C5.237,13.921,5.038,12.768,5.018,11.613z M22.408,3.782c-4.649-4.65-10.759-3.023-14.563,0.782 C6.436,5.971,5.551,7.702,5.186,9.516l11.485,11.486c1.814-0.365,3.546-1.248,4.953-2.656C25.43,14.54,27.06,8.433,22.408,3.782z"/> </g> </g> </g>
                
            </svg>        
    );
}
 
export default Sport;